import YoutubeComponent from "./youtubeComponent";
import styled from "styled-components";

const Container = styled.div`
  width: 100%;
  height: 100%;
  /* background-color: red; */
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
`;

const VideoItem = styled.div`
  margin-bottom: 4vw;
  width: 42vw;
  height: 28vw;
  /* border: 1px dashed red; */
`;

const TitleArea = styled.div`
  display: flex;
  align-items: center;
  font-size: 2.6vw;
  font-weight: 600;
  height: 4vw;
  margin-bottom: 1vw;
`;

export default function IntroductionVideoList() {
  const VideoData = [
    { id: 1, title: "1. 통인익스프레스 홍보영상", videoId: "pGyAOMOC-Ps" },
    { id: 2, title: "2. 무브제", videoId: "xSwnfd8gzs8" },
    { id: 3, title: "3. 스탠다드 이사", videoId: "rCl971ZSPAc" },
    { id: 4, title: "4. 프리미엄 이사", videoId: "CgBVQoM0DqA" },
    { id: 5, title: "5. 수납 이사", videoId: "4HtcjMcG7S4" },
    { id: 6, title: "6. 입주 청소", videoId: "NYtwwKK1ccM" },
  ];

  return (
    <>
      <Container>
        {VideoData.map((item: any) => {
          return (
            <VideoItem key={item.id}>
              <TitleArea>{item.title}</TitleArea>
              <YoutubeComponent videoId={item.videoId}></YoutubeComponent>
            </VideoItem>
          );
        })}
      </Container>
    </>
  );
}
